import { useEffect, useState } from "react";
import { fetchUserSettings, updateUserSettings, type UserSettings } from "../api/settings.ts";
import { useToast } from "../components/ToastProvider.tsx";

const DEFAULT_SETTINGS: UserSettings = {
  autoCorrectOutgoing: false,
};

export function Settings() {
  const { showToast } = useToast();
  const [settings, setSettings] = useState<UserSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetchUserSettings()
      .then((data) => {
        if (!active) return;
        setSettings(data);
        setError("");
      })
      .catch((err) => {
        if (!active) return;
        setError(err instanceof Error ? err.message : "Falha ao carregar configuracao");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  async function setAutoCorrectOutgoing(enabled: boolean) {
    const previous = settings;
    setSettings({ ...settings, autoCorrectOutgoing: enabled });
    setSaving(true);
    setError("");
    try {
      const saved = await updateUserSettings({ autoCorrectOutgoing: enabled });
      setSettings(saved);
      showToast(enabled ? "Correcao automatica ativada" : "Correcao automatica desativada", "success");
    } catch (err) {
      setSettings(previous);
      const message = err instanceof Error ? err.message : "Falha ao salvar configuracao";
      setError(message);
      showToast(message, "error");
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="settings-shell" aria-label="Configuracao">
      <header className="settings-head">
        <div>
          <h1>Configuracao</h1>
          <p>Preferencias do vendedor</p>
        </div>
      </header>

      <div className="settings-list">
        <article className="settings-card">
          <div className="settings-card-copy">
            <span className="settings-eyebrow">Mensagens</span>
            <h2>Correcao de texto</h2>
            <p>Corrigir acentuacao e pontuacao antes de enviar</p>
          </div>
          <label className={`settings-toggle ${settings.autoCorrectOutgoing ? "is-on" : ""}`}>
            <input
              type="checkbox"
              checked={settings.autoCorrectOutgoing}
              disabled={loading || saving}
              onChange={(event) => void setAutoCorrectOutgoing(event.currentTarget.checked)}
            />
            <span className="settings-toggle-track" aria-hidden="true">
              <span className="settings-toggle-thumb" />
            </span>
            <span className="settings-toggle-label">
              {settings.autoCorrectOutgoing ? "Ativado" : "Desativado"}
            </span>
          </label>
        </article>
      </div>

      {error ? <div className="settings-alert">{error}</div> : null}
    </section>
  );
}
